/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Civilization, resource type
 */
export interface CivNameAction { 
    /**
     * Civilization name
     */
    civilizationName: string;
    /**
     * Name of an object
     */
    name: string;
}